<template>
  <div>
    <PcContainer :channelData="channelData">
      <template slot="center">
        <div class="container-center-center">
          <p class="tips" style="font-size:16px;color:#646464;">请输入口令验证</p>
          <van-form class="form">
            <van-field
              v-model="word"
              type="tel"
              placeholder="请输入口令完成验证"
              class="input"
              style="margin-bottom: 0.56rem"
            ></van-field>
          </van-form>
          <van-button
            size="large"
            color="#3667EC"
            square
            @click="finish"
            :disabled="word === ''"
            class="btn"
          >完成验证</van-button>
          <van-button type="default" @click="onLogout" class="btn">退 出</van-button>
        </div>
      </template>
    </PcContainer>
  </div>
</template>

<script>
import PcContainer from '@/components/pclogin/pcContainer';
import { jumpBeforeRegisterUrl } from '@/utils/storage';
import { mapState } from 'vuex';
import { customerUser } from '@/api/ajax';
export default {
  name: 'pcRegiser',
  components: {
    PcContainer
  },
  data() {
    return {
      word: ''
    };
  },
  computed: {
    ...mapState({
      channelData: state => state.channel.info
    })
  },
  methods: {
    finish() {
      customerUser
        .channelCommand({
          command: this.word
        })
        .then(res => {
          let jumpUrl = jumpBeforeRegisterUrl();
          if (!jumpUrl) {
            this.$router.push({
              name: 'home'
            });
          }
        });
    },
    async onLogout() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push({ name: 'register' });
    }
  }
};
</script>

<style lang="less" scoped>
.form {
  margin-top: 0.3rem;
  .van-cell {
    padding: 0;
    width: 368px;
    height: 40px;
    background: #f6f6f6;
    margin: 0 0 0 72px;
    /deep/input {
      padding-left: 18px;
      height: 40px;
      font-size: 14px !important;
    }
  }
  p {
    font-size: 0.32rem;
    color: #323235;
    &.tips {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #646464;
      line-height: 18px;
    }
  }
}
.btn {
  width: 368px;
  height: 40px;
  border-radius: 3px;
  & + .btn {
    margin-top: 17px;
  }
}
</style>
